import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Console } from 'console';
import { chownSync } from 'fs';
import { Subscription } from 'rxjs';
import { PermissionPrefix, PermissionType } from 'src/api/models';
import { ControlPanelService } from 'src/states/control-panel.service';

@Component({
  template: ''
})
export abstract class BaseComponent implements OnInit, OnDestroy {

  public CanRead: boolean = false;
  public CanCreate: boolean = false;
  public CanWrite: boolean = false;
  public CanDisable: boolean = false;
  public CanDelete: boolean = false;

  public Subscriptions: Array<Subscription> = new Array();

  constructor(
    controlPanelService: ControlPanelService,
    permissionPrefix: PermissionPrefix
  ) {
    const prefixName = PermissionPrefix[permissionPrefix];
    this.CanRead = controlPanelService.HavePermission(prefixName + '.' + PermissionType[PermissionType.Lecture]);
    this.CanCreate = controlPanelService.HavePermission(prefixName + '.' + PermissionType[PermissionType.Ecriture]);
    this.CanWrite = controlPanelService.HavePermission(prefixName + '.' + PermissionType[PermissionType.Modification]);
    this.CanDisable = controlPanelService.HavePermission(prefixName + '.' + PermissionType[PermissionType.Desactivation]);
    this.CanDelete = controlPanelService.HavePermission(prefixName + '.' + PermissionType[PermissionType.Suppression]);
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.Subscriptions.forEach( s => {
      console.log('Auto unsubscribe', s);
      s.unsubscribe();
    });
  }

  HavePermission(controlPanelService: ControlPanelService, prefix: PermissionPrefix, type : PermissionType) : boolean {
    const prefixName = PermissionPrefix[prefix];
    const permissionName = PermissionType[type]
    return controlPanelService.HavePermission( prefixName + '.' + permissionName );
  }

  HaveMenuPermission(controlPanelService: ControlPanelService, prefix: PermissionPrefix, type : string) : boolean {
    const prefixName = PermissionPrefix[prefix];
    const permissionName = type;
    return controlPanelService.HavePermission( prefixName + '.' + permissionName );
  }
}
